export default {
    getCurrentSiteSettings(state){
        return state.siteSettings;
    }
}